import { render, staticRenderFns } from "./AccountingBooksAccountsForm.vue?vue&type=template&id=faf256a6&"
import script from "./AccountingBooksAccountsForm.vue?vue&type=script&lang=js&"
export * from "./AccountingBooksAccountsForm.vue?vue&type=script&lang=js&"
import style0 from "./AccountingBooksAccountsForm.vue?vue&type=style&index=0&id=faf256a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports